// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"d4e2df36","838":"e759c36a"}[chunkId] + ".js";
};